import { render } from "./SectionTotalSummary.vue?vue&type=template&id=205d851c"
import script from "./SectionTotalSummary.vue?vue&type=script&lang=js"
export * from "./SectionTotalSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__